import {CountryInfo, MobileNumberValue} from "../type/phone-input.type";

const API_URL =
    'https://countriesnow.space/api/v0.1/countries/info?returns=flag,unicodeFlag,dialCode';

export async function fetchCountries(): Promise<CountryInfo[]> {
    const res = await fetch(API_URL);
    if (!res.ok) throw new Error(`API error: ${res.status}`);
    const json = await res.json();
    return (json.data as CountryInfo[]).filter(
        (c) => c.dialCode && c.dialCode.trim() !== ''
    );
}


/** Stable key — name is unique; dial codes are not (many countries share them). */
export const countryKey = (c: CountryInfo) => `${c.name}__${c.dialCode}`;